export const themeJson = {
  "themeName": "layered",
  "colorPalette": "light",
  "isPanelless": false, /* H-Farm использует открытую верстку без явных "карточек" границ */
  "backgroundImage": "",
  "backgroundOpacity": 1,
  "backgroundImageAttachment": "scroll",
  "backgroundImageFit": "cover",
  "cssVariables": {
    /* -- ГЕОМЕТРИЯ (SHAPES) -- */
    /* Pill-shape (таблетка) для кнопок и инпутов, как на скриншоте формы */
    "--sjs-corner-radius": "32px",
    "--sjs-base-unit": "8px",

    /* -- ТЕНИ (SHADOWS) -- */
    /* Дизайн в буклете очень "плоский" (flat), убираем лишние тени */
    "--sjs-shadow-small": "0px 0px 0px 0px rgba(0, 0, 0, 0)",
    "--sjs-shadow-medium": "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
    "--sjs-shadow-large": "0px 0px 0px 0px rgba(0, 0, 0, 0)",
    "--sjs-shadow-inner": "inset 0px 1px 2px 0px rgba(0, 0, 0, 0.05)",

    /* -- ГРАНИЦЫ (BORDERS) -- */
    /* В покое границы легкие, при ошибке — яркие */
    "--sjs-border-default": "rgba(0, 0, 0, 0.12)",
    "--sjs-border-light": "rgba(0, 0, 0, 0.08)",
    "--sjs-border-inside": "rgba(0, 0, 0, 0.08)",

    /* -- ЦВЕТА ФОНА (BACKGROUNDS) -- */
    "--sjs-general-backcolor": "#FFFFFF",
    "--sjs-general-backcolor-dark": "#F4F4F4",
    "--sjs-general-backcolor-dim-light": "#F9F9F9", /* Цвет фона инпутов в покое */
    "--sjs-general-backcolor-dim-dark": "#EDEDED",

    /* -- ТЕКСТ (FOREGROUND) -- */
    "--sjs-general-forecolor": "#222222",
    "--sjs-general-forecolor-light": "#666666",
    "--sjs-general-dim-forecolor": "#222222",
    "--sjs-general-dim-forecolor-light": "#888888",

    /* -- PRIMARY COLOR (H-FARM RED) -- */
    /* Брендовый красный из буклета */
    "--sjs-primary-backcolor": "#C1111E",
    "--sjs-primary-backcolor-dark": "#A30E19",
    "--sjs-primary-backcolor-light": "rgba(193, 17, 30, 0.1)",
    "--sjs-primary-forecolor": "#FFFFFF",
    "--sjs-primary-forecolor-light": "rgba(255, 255, 255, 0.3)",

    /* -- ОШИБКИ (ERROR STATES) - Ключевой момент -- */
    /* Настраиваем так, чтобы фон становился розовым, а границы красными */
    "--sjs-special-red": "#C1111E",            /* Цвет текста ошибки и границы */
    "--sjs-special-red-light": "rgba(193, 17, 30, 0.12)", /* РОЗОВЫЙ ФОН для плашки ошибки и инпута */
    "--sjs-special-red-forecolor": "#C1111E",  /* Текст внутри блока ошибки */

    /* Остальные спец. цвета (для успеха и т.д.) */
    "--sjs-special-green": "#00875A",
    "--sjs-special-green-light": "rgba(0, 135, 90, 0.1)",
    "--sjs-special-blue": "#023048",
    "--sjs-special-blue-light": "rgba(2, 48, 72, 0.1)",
    "--sjs-special-yellow": "#FF9814",
    "--sjs-special-yellow-light": "rgba(255, 152, 20, 0.1)",

    /* -- ШРИФТЫ (TYPOGRAPHY) -- */
    /* В буклете используется чистый гротеск (Helvetica/Inter).
       Заголовки часто UPPERCASE (прописные). */

    /* Заголовок опроса */
    "--sjs-article-font-xx-large-fontFamily": "'Inter', 'Helvetica Neue', Arial, sans-serif",
    "--sjs-article-font-xx-large-fontWeight": "800",
    "--sjs-article-font-xx-large-lineHeight": "1.1",
    "--sjs-article-font-xx-large-textCase": "uppercase", /* Стиль буклета */
    "--sjs-article-font-xx-large-fontSize": "32px",

    /* Подзаголовки / Названия страниц */
    "--sjs-article-font-x-large-fontFamily": "'Inter', 'Helvetica Neue', Arial, sans-serif",
    "--sjs-article-font-x-large-fontWeight": "700",
    "--sjs-article-font-x-large-textCase": "none",
    "--sjs-article-font-x-large-fontSize": "24px",
    "--sjs-article-font-x-large-forecolor": "#C1111E", /* Красные заголовки страниц как в буклете */

    /* Заголовки вопросов */
    "--sjs-article-font-large-fontFamily": "'Inter', 'Helvetica Neue', Arial, sans-serif",
    "--sjs-article-font-large-fontWeight": "600",
    "--sjs-article-font-large-fontSize": "18px",
    "--sjs-article-font-large-lineHeight": "1.4",
    "--sjs-article-font-large-textCase": "none",
    "--sjs-article-font-large-forecolor": "#222222",

    /* Основной текст и поля ввода */
    "--sjs-article-font-default-fontFamily": "'Inter', 'Helvetica Neue', Arial, sans-serif",
    "--sjs-article-font-default-fontWeight": "400",
    "--sjs-article-font-default-fontSize": "16px",
    "--sjs-article-font-default-lineHeight": "1.5",

    /* -- UI Elements Adjustment -- */
    "--sjs-editor-background": "#F3F3F3", /* Серый фон инпутов по умолчанию (см. скриншот) */
    "--sjs-questionpanel-backcolor": "#FFFFFF",
  },
  "header": {
    "height": 120,
    "textAreaWidth": 600,
    "inheritWidthFrom": "container",
    "logoPositionX": "right",
    "logoPositionY": "top",
  },
  "headerView": "advanced"
};